<script setup>
import { useI18n } from 'vue-i18n';
import { useStore } from 'dashboard/composables/store';
import { useAlert } from 'dashboard/composables';

import SlaForm from './SlaForm.vue';

const emit = defineEmits(['close']);

const store = useStore();
const { t } = useI18n();

const onClose = () => {
  emit('close');
};

const addSLA = async payload => {
  try {
    await store.dispatch('sla/create', payload);
    useAlert(t('SLA.ADD.API.SUCCESS_MESSAGE'));
    onClose();
  } catch (error) {
    useAlert(error.message || t('SLA.ADD.API.ERROR_MESSAGE'));
  }
};
</script>

<template>
  <div class="flex flex-col h-auto overflow-auto">
    <woot-modal-header
      :header-title="$t('SLA.ADD.TITLE')"
      :header-content="$t('SLA.ADD.DESC')"
    />
    <SlaForm
      :submit-label="$t('SLA.FORM.CREATE')"
      @submit-sla="addSLA"
      @close="onClose"
    />
  </div>
</template>
